import httpClient from 'src/common/fetch/config'

export type PasskeyEvent = 'added' | 'removed' | 'renamed'
export type SigninMethod = 'passkey' | 'password'

export interface PasskeyLabel {
  credentialId: string
  label: string
}

// Reports a passkey lifecycle event so the backend can persist the label, send the security email
// (added/removed), and write the audit row.
export const notifyPasskeyEvent = (body: { event: PasskeyEvent; credentialId: string; label?: string }) =>
  httpClient.post<{ success: true }>('/account-security/passkeys/notify', body)

// Returns the user's stored passkey labels to merge with Cognito's credential list.
export const getPasskeyLabels = () => httpClient.get<{ labels: PasskeyLabel[] }>('/account-security/passkeys/labels')

// Records a successful sign-in (passkey/password) in the audit trail.
export const recordSigninEvent = (method: SigninMethod) =>
  httpClient.post<{ success: true }>('/account-security/signin-event', { method })
